// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"BlueButton_buttonWrapper__anY9m"};